// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Gallery_pageContent__MwuV6","videoGroup":"Gallery_videoGroup__9--Rn","videoContainer":"Gallery_videoContainer__zXIMs","singleVideo":"Gallery_singleVideo__oXVSC"};